import { InnerLabelTextfield, TextField } from "components/commons";
import React from "react";
import { formatNumber, unformatNumber, checkIfValidByDecimalPlaces } from "utils";

const InputAmount = ({ className, onChange, innerLabel, ...props }) => {
  const componentProps = {
    ...props,
    className,
    onChange: (name, { value }) => {
      const integerPart = value.toString().split(".")[0].replace(/,/g, "");
      if (integerPart.length > 13) return;
      if (checkIfValidByDecimalPlaces(value, 2) || !value) {
        onChange(name, { value });
      }
    },
    onBlur: (name, { value }) => {
      if (value) {
        onChange(name, { value: `${formatNumber(value, 2)}` });
      }
    },

    onFocus: () => {
      if (props.value) {
        const value = unformatNumber(props.value);
        onChange(props.name, { value: value || "" });
      }
    },
  };
  if (innerLabel) {
    return <InnerLabelTextfield {...componentProps} prefix="₱" />;
  }
  return <TextField {...componentProps} />;
};

export default InputAmount;
